<template>
  <div class="toast">
    <img :src="icon"><br>
    <span>{{text}}</span>
  </div>
</template>

<script>
export default {
  props: [
    'icon',
    'text'],
  created: function () {
    setTimeout(() => {
      this.$emit('close')
    }, 2000);
  }
}
</script>
<style lang="less" scoped>
 .toast {
   width: 180px;
   margin: auto auto;
   text-align: center;
   padding: 34px 20px;
   background: #000000cc;
   border-radius: 8px;
   box-sizing: border-box;
   span {
     margin-top: 23px;
     font-size: 18px;
     font-weight: normal;
     color: #FFF;
   }
 }
</style>
